import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { AUTH_CONSTANTS } from '../../auth/auth-constants';
import { ResizeEvent } from 'angular-resizable-element';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
const _ = require('lodash');

@Component({
    selector: 'administration-main',
    providers: [],
    encapsulation: ViewEncapsulation.None,
    styles: [require('./administration.scss')],
    // host: {'[class.content-container]': 'true'},
    template: require('./administration-main.html'),
})
export default class AdministrationMain {
    private isVCEnvironment: boolean = false;
    private sideNavStyle: Object = {};
    private isTranslationready: boolean = true;
    private isSystemAdmin: boolean = false;
    private disableDeploymentContainers: boolean = true;
    private disableLegacyInterconnectConfiguration: boolean = false;
    constructor(public authService: AuthService, private translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
        const roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, AUTH_CONSTANTS.SysAdmin)) {
            this.isSystemAdmin = true;
        }
    }

    ngOnInit(){
        if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD) {
            this.isVCEnvironment = false;
        } else if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VC) {
            this.isVCEnvironment = true;
        }
    }

    // TODO update to use featureConfig API - This is only for DEMO of HCX Onprem SA 2/2019
    private isFeatureEnabled(feature: string, operation: string): boolean {

        if (feature === 'IX_CONFIG_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/administration-main.component.ts